"use strict";

var _Box;
import { Box } from '@autoguru/overdrive';
import { jsx as _jsx } from "react/jsx-runtime";
export const userMenuElementId = '__ag-user-menu__';
export const UserMenuHolder = () => _Box || (_Box = /*#__PURE__*/_jsx(Box, {
  role: "navigation",
  "aria-label": "Main aside",
  as: "nav",
  id: userMenuElementId
}));